import { IpaRow } from "./Ipa";
import { IpaChartProps } from "./IpaChart";

/** show IPA non-pulmonic consonants chart */
export function NonPulmonicChart(props: IpaChartProps) {
  return (
    <table>
      <thead>
        <tr>
          <th>Clicks</th>
          <th>Voiced<br />implosives</th>
          <th>Ejectives</th>
        </tr>
      </thead>
      <tbody>
        <IpaRow symbols={['ʘ', 'ɓ', 'ʼ']} chartProps={props} />
        <IpaRow symbols={['ǀ', 'ɗ', 'pʼ']} chartProps={props} />
        <IpaRow symbols={['ǃ', 'ʄ', 'tʼ']} chartProps={props} />
        <IpaRow symbols={['ǂ', 'ɠ', 'kʼ']} chartProps={props} />
        <IpaRow symbols={['ǁ', 'ᶑ', 'sʼ']} chartProps={props} />
      </tbody>
    </table>
  )
}
